module.exports = __webpack_public_path__ + "img/card.b3ea2c46.svg";